/**
 * 404 — страница не найдена.
 * URL: любой нераспознанный путь → fallback в App.tsx.
 */
import { ErrorLayout, ErrorBlock } from '@/components/layout/ErrorLayout'
import { Button } from '@/components/ui/Button'

export function NotFound() {
  return (
    <ErrorLayout>
      <ErrorBlock
        icon="ghost"
        iconTone="muted"
        title="Не нашли страницу 🤔"
        body={
          <p>
            Похоже, такой страницы не существует. Возможно, ссылка устарела или адрес ввели с опечаткой.
          </p>
        }
        actions={
          <>
            <Button asChild variant="primary"><a href="/">На главную</a></Button>
            <Button asChild variant="secondary"><a href="/auth/login">Войти</a></Button>
          </>
        }
      />
    </ErrorLayout>
  )
}
